import { ModalContainer } from 'src/components/Modals/components';
import { MvpDesignFooter } from 'src/components/Modals/styles';
import React from 'react';
import { t } from 'i18next';
import Header from 'src/components/Modals/components/ModalHeader/ModalHeader';
import {
  IconStyled,
  MessageContainer,
  Time,
} from 'src/components/Modals/SessionTimeout/styles';
import Countdown from 'react-countdown';
import Footer from 'src/components/Modals/SessionTimeout/Footer';

interface ISessionTimeout {
  onConfirm?: () => void;
  onCancel?: () => void;
  onCountdownComplete: () => void;
  timeout: number;
  footer?: JSX.Element;
  title?: string;
}

const MvpSessionTimeout = ({
  onCancel,
  onConfirm,
  timeout,
  onCountdownComplete,
  title,
}: ISessionTimeout) => {
  return (
    <ModalContainer aria-modal="true" aria-live="off" width={360}>
      <IconStyled
        style={{ margin: '16px 0 0 16px', fontSize: '2rem' }}
        type="clock"
        aria-label=""
      />
      <div>
        <Header title={title} onClick={onCancel} />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            margin: '0 16px 10px 26px',
          }}
        >
          <MessageContainer>
            <div>
              <p>{t('SessionExpirationTimeoutMessage')}</p>
            </div>
            <div>
              <Time>
                <Countdown
                  date={Date.now() + timeout * 1000}
                  renderer={x => x.seconds}
                  onComplete={onCountdownComplete}
                />{' '}
                {t('sec')}
              </Time>
            </div>
            <div>
              <p>{t('SessionExpirationMessage')}</p>
            </div>
          </MessageContainer>

          <MvpDesignFooter>
            <Footer onConfirm={onConfirm} onCancel={onCancel} />
          </MvpDesignFooter>
        </div>
      </div>
    </ModalContainer>
  );
};

export default MvpSessionTimeout;
